var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { focusTrap } from '../lib-focusTrap';
import { scrollLock } from '../lib-scrollLock';
import { focusFirstAvailable } from '../lib-focusFirstAvailable';
import { componentApi } from '../component-api-lib';
import * as React from 'react';
var SideModal = /** @class */ (function (_super) {
    __extends(SideModal, _super);
    function SideModal(props) {
        var _this = _super.call(this, props) || this;
        _this.emit = componentApi.emit.bind(_this);
        _this.writeState = componentApi.writeState.bind(_this);
        _this.contentElement = React.createRef();
        _this.removeFocusTrap = function () { };
        _this.removeScrollLock = function () { };
        _this.prevActiveElement = null;
        _this.pendingAnimations = [];
        _this.keyframesFromCss = 'cg3-side-modal-content-opacity-opening cg3-keyframes-side-modal-content-left-opening cg3-keyframes-side-modal-content-right-opening cg3-keyframes-side-modal-content-left-closing cg3-keyframes-side-modal-content-right-closing cg3-keyframes-side-modal-opacity';
        _this.isPropChanged = componentApi.isPropChanged.bind(_this);
        _this.isStateChanged = componentApi.isStateChanged.bind(_this);
        _this.userRequest = 'onUserRequest';
        _this.openBegin = 'onOpenBegin';
        _this.openEnd = 'onOpenEnd';
        _this.closeBegin = 'onCloseBegin';
        _this.closeEnd = 'onCloseEnd';
        _this.state = {};
        _this.state['_isOpen'] = Boolean(_this.props.isOpen);
        _this.state['stage'] = _this.state._isOpen ? 'open' : 'closed';
        _this.onAnimationStart = _this.onAnimationStart.bind(_this);
        _this.onAnimationEnd = _this.onAnimationEnd.bind(_this);
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.onClose = _this.onClose.bind(_this);
        return _this;
    }
    SideModal.prototype.render = function () {
        var _this = this;
        return this.isInDom() ? (React.createElement("div", { "aria-modal": "true", role: "dialog", "aria-hidden": "false", "aria-labelledby": this.props.srLabelledBy, "flow-id": this.props.flowId, onAnimationStart: function (event) { return _this.onAnimationStart(event); }, onAnimationEnd: function (event) { return _this.onAnimationEnd(event); }, onKeyDown: function (event) { return _this.onKeyDown(event); }, className: (this.isOpening() ? 'cg3-is-opening ' : '') +
                (this.isClosing() ? 'cg3-is-closing ' : '') +
                this.getClasses('cg3-side-modal') },
            React.createElement("div", { "flow-id": "side-modal-overlay", onClick: function () { return _this.onClose('overlay'); }, className: "cg3-side-modal-overlay" }),
            React.createElement("div", { ref: this.contentElement, tabIndex: -1, "flow-id": "side-modal-content", className: 'cg3-side-modal-content ' +
                    (this.props.position === 'left'
                        ? 'cg3-side-modal-content-left '
                        : '') +
                    (this.props.position === 'right'
                        ? 'cg3-side-modal-content-right '
                        : '') }, this.props.children))) : null;
    };
    SideModal.prototype.cg_change = function (prevProps) {
        if (this.becameTrue('isOpen', prevProps)) {
            this.prevActiveElement = document.activeElement;
        }
        else if (this.becameFalse('isOpen', prevProps)) {
            if (this.prevActiveElement) {
                this.prevActiveElement.focus();
            }
        }
        if (this.isOpening() && prevProps.stage === 'closed') {
            this.lockScrollAndFocus();
        }
        if (prevProps.stage === 'closing' && this.state.stage === 'closed') {
            this.unlockScrollAndFocus();
        }
        if (this.isPropChanged('isOpen', prevProps) &&
            this.props.isOpen !== undefined) {
            this.writeState('_isOpen', this.props.isOpen);
        }
        if (this.becameTrue('_isOpen', prevProps, 'state')) {
            this.writeState('stage', 'opening');
            this.emit(this.openBegin);
        }
        else if (this.becameFalse('_isOpen', prevProps, 'state')) {
            this.writeState('stage', 'closing');
            this.emit(this.closeBegin);
        }
    };
    SideModal.prototype.onKeyDown = function (e) {
        if (e.key === 'Esc' || e.key === 'Escape') {
            this.onClose('esc');
        }
    };
    SideModal.prototype.onClose = function (event) {
        this.emit(this.userRequest, event);
    };
    SideModal.prototype.lockScrollAndFocus = function () {
        var content = this.contentElement.current;
        focusFirstAvailable(content, this.props.toFocus);
        this.removeFocusTrap = focusTrap(content);
        this.removeScrollLock = scrollLock();
    };
    SideModal.prototype.unlockScrollAndFocus = function () {
        this.removeFocusTrap();
        this.removeScrollLock();
    };
    SideModal.prototype.isInDom = function () {
        return this.state.stage !== 'closed';
    };
    SideModal.prototype.isClosing = function () {
        return this.state.stage === 'closing';
    };
    SideModal.prototype.isOpening = function () {
        return this.state.stage === 'opening';
    };
    SideModal.prototype.onAnimationStart = function (e) {
        if (!this.isContainerAnimation(e)) {
            return;
        }
        if (!this.pendingAnimations.includes(e.animationName)) {
            this.pendingAnimations = this.pendingAnimations.concat(e.animationName);
        }
    };
    SideModal.prototype.onAnimationEnd = function (e) {
        if (!this.isContainerAnimation(e)) {
            return;
        }
        this.pendingAnimations = this.pendingAnimations.filter(function (animationName) { return animationName !== e.animationName; });
        if (this.pendingAnimations.length > 0) {
            return;
        }
        if (this.state.stage === 'opening') {
            this.writeState('stage', 'open');
            this.emit(this.openEnd);
        }
        else if (this.state.stage === 'closing') {
            this.writeState('stage', 'closed');
            this.emit(this.closeEnd);
        }
    };
    SideModal.prototype.isContainerAnimation = function (e) {
        return this.keyframesFromCss.includes(e.animationName);
    };
    SideModal.prototype.becameTrue = function (propName, prevProps, type) {
        if (type === void 0) { type = 'prop'; }
        if (type === 'prop') {
            return (this.isPropChanged(propName, prevProps) &&
                !prevProps[propName] &&
                this.props[propName]);
        }
        return (this.isStateChanged(propName, prevProps) &&
            !prevProps[propName] &&
            this.state[propName]);
    };
    SideModal.prototype.becameFalse = function (propName, prevProps, type) {
        if (type === void 0) { type = 'prop'; }
        if (type === 'prop') {
            return (this.isPropChanged(propName, prevProps) &&
                prevProps[propName] &&
                !this.props[propName]);
        }
        return (this.isStateChanged(propName, prevProps) &&
            prevProps[propName] &&
            !this.state[propName]);
    };
    SideModal.prototype.getClasses = function (base) {
        return (base + ' ' + this.props.flowClass).trim() + ' ';
    };
    SideModal.prototype.componentDidMount = function () {
        if (this.props.isOpen) {
            this.lockScrollAndFocus();
        }
    };
    SideModal.prototype.componentWillUnmount = function () {
        this.unlockScrollAndFocus();
    };
    SideModal.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.cg_change(__assign(__assign({}, prevProps), prevState));
    };
    SideModal.defaultProps = {
        position: 'right',
        toFocus: 'button',
        flowId: 'side-modal',
        flowClass: '',
    };
    SideModal.displayName = 'SideModal';
    return SideModal;
}(React.Component));
export { SideModal };
